import { api } from "@/lib/api";

export const dispatchApi = {
  meta: () => api.get("/dispatch/meta").then((r) => r.data),
  stats: () => api.get("/dispatch/stats").then((r) => r.data),
  salesOrders: () => api.get("/dispatch/sales-orders").then((r) => r.data),
  reservable: (so_no) => api.get("/dispatch/reservable", { params: { so_no } }).then((r) => r.data),
  list: (params) => api.get("/dispatch/dispatches", { params }).then((r) => r.data),
  get: (id) => api.get(`/dispatch/dispatches/${id}`).then((r) => r.data),
  create: (body) => api.post("/dispatch/dispatches", body).then((r) => r.data),
  update: (id, body) => api.put(`/dispatch/dispatches/${id}`, body).then((r) => r.data),
  setStatus: (id, status, note) => api.patch(`/dispatch/dispatches/${id}/status`, { status, note }).then((r) => r.data),
};

export const DISPATCH_STATUS_STYLE = {
  Planning: "bg-slate-100 text-slate-700",
  "Ready to Pick": "bg-blue-50 text-blue-700 border border-blue-200",
  Picked: "bg-violet-50 text-violet-700 border border-violet-200",
  Loaded: "bg-amber-50 text-amber-700 border border-amber-200",
  Dispatched: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  Delivered: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Closed: "bg-slate-200 text-slate-500",
};
